import React from 'react';
import { get, map } from 'lodash';
import classnames from 'classnames';

// local dependencies
import { memberAddEditAddresspreloader } from 'ui/views/widgets/memberAddEditAddress';
import { withNetworkState } from 'ui/hoc/withNetworkState';
import { Icon } from 'modules/icon-bank';
import { getLabel } from 'utils/getLabel';
import { radioBox as RadioBox } from 'ui/views/generic/radioBox';
import { getDisplayValue } from 'resolvers/formatValue';

// _memberCheckoutShippingOptions view
const _memberCheckoutShippingOptions = ( props ) => {

    // widget title
    const title = get( props, 'widgetConfig.title', {} );

    // address list
    const shippingOptions = get( props, 'shippingOptions', [] );

    // fields
    const fields = get( props, 'fields', [] );

    return (
        <div className='ui-member-checkout-shipping-options'>
            
            {/* widget title */}
            <div className='ui-member-checkout-shipping-options__header'>
                <Icon id={ 'shippingOption' } />
                <div className='ui-member-checkout-shipping-options__header__title'>
                    { getLabel( title ) }
                </div>
            </div>

            <div className='ui-member-checkout-shipping-options__body'>

                { map( shippingOptions, option => {

                    const className = classnames( 'ui-member-checkout-shipping-options__body__card', {
                            'ui-member-checkout-shipping-options__body__card--selected': get( option, 'selected', false ),
                            'ui-member-checkout-shipping-options__body__card--highlight': get( option, 'flags.isMsrExclusive', false )
                        }
                    );

                    return(
                        <div className={ className } key={ option.id }>

                            <div className='ui-member-checkout-shipping-options__body__card__header' onClick={ () => props.onShippingOptionSelection( option ) }>
                                <RadioBox selected={ get( option, 'selected', false ) } />
                                { option.name }
                            </div>

                            <div className='ui-member-checkout-shipping-options__body__card__body'>

                                { map( fields, field => {

                                    const displayValue = getDisplayValue( { type: field.type, value: option[ `${field.name}` ] } );

                                    return (
                                        <div key={ field.name } className='ui-member-checkout-shipping-options__body__card__body__section'>
                                            <div className='ui-member-checkout-shipping-options__body__card__body__section__title'>{ getLabel( field.title ) }</div>
                                            <div className='ui-member-checkout-shipping-options__body__card__body__section__value'>{ displayValue }</div>
                                        </div>
                                    );
                                } ) }
                            </div>

                        </div>
                    );
                } ) }
            </div>
        </div>
    );
};

// set display name
_memberCheckoutShippingOptions.displayName = 'memberCheckoutShippingOptions';

// set default props
_memberCheckoutShippingOptions.defaultProps = {};

// prop types
_memberCheckoutShippingOptions.propTypes = {};

/**
 * @type {object}
 * @desc A React presentation/dumb view component.
 * @example
 * import { memberCheckoutShippingOptions as MemberCheckoutShippingOptions } from 'ui/views/widgets/memberCheckoutShippingOptions';
 *
 * // render
 * <MemberCheckoutShippingOptions propName='propValue'/>
 */
export const memberCheckoutShippingOptions = withNetworkState( memberAddEditAddresspreloader, _memberCheckoutShippingOptions );
